$(function(){
	$('.insurance-case').each(function () {

		$('.insurance-item__head').on('click', function () {
			$(this).next('.insurance-item__body').slideToggle(500);
			$(this).toggleClass('js-faq-active')
		});

		$('.js-dropdown-close').on('click', function () {
			$(this).closest('.insurance-item__body').slideToggle(200);
			$(this).closest('.insurance-item').find('.insurance-item__head').toggleClass('js-faq-active')

			$('html, body').animate({
				scrollTop: $($(this).attr('data-href')).offset().top - 150
			}, 0);

		});
	});
});
